import React from 'react';
import { ListItemProgressIndicator } from 'components/List';

/** MoreButton menu item which supports icon.
 * Any other props will be provided to the wrapper element.
 */
const MoreButtonItemProgressIndicator = React.forwardRef<HTMLElement>((props, ref) => <ListItemProgressIndicator ref={ref} {...props} />);

MoreButtonItemProgressIndicator.displayName = 'MoreButtonItemProgressIndicator';

export default MoreButtonItemProgressIndicator;
